/**
 * 从 AllAll / OpenAI 风格错误体中取出可读文案。
 * 常见结构：{ message, code, error: { message, type } } 或 { code, msg }
 */
export function extractApiErrorMessage(data) {
  if (data == null) return ''
  if (typeof data === 'string') return data.trim()
  if (typeof data !== 'object') return String(data)

  var top = data.message != null ? String(data.message).trim() : ''
  if (top) return top

  /* 部分接口用 msg 而非 message */
  var m = data.msg != null ? String(data.msg).trim() : ''
  if (m) return m

  var e = data.error
  if (typeof e === 'string') return e.trim()
  if (e && typeof e === 'object' && e.message != null) {
    var em = String(e.message).trim()
    if (em) return em
  }

  if (data.description != null) {
    var d = String(data.description).trim()
    if (d) return d
  }

  return ''
}
